var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"button-icon",style:(_vm.buttonStyle),attrs:{"variant":_vm.variant,"size":"md","pill":_vm.pill,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:`icon-${_vm.icon}`,style:(_vm.iconStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }